<template>
  <div style="padding: 20px;background-color: #ffffff;">
    <div class="">
      <div @keyup.enter.stop="getPage({pageNum: 1})">
        <el-input style="width:200px;margin-right:10px;margin-bottom: 10px;" @clear="getPage({pageNum: 1})" v-model="queryParam.id" clearable placeholder="用户ID"></el-input>
        <el-select v-model="queryParam.isEnable" placeholder="状态" filterable style="width:200px;margin-right:10px;">
          <el-option v-for="(item,index) in Tool.map2arr($enums.isEnable)" :key="index" :label="item.value" :value="item.key" :class="item.disabled?'none':''"></el-option>
        </el-select>
        <!--        <el-select v-model="queryParam.specialtyId" placeholder="所属话题" @change="getPage({pageNum: 1})" filterable clearable style="width:200px;margin-right:10px;margin-bottom: 10px;">-->
        <!--          <el-option v-for="(item,index) in specialtyList" :key="index" :label="item.specialtyName" :value="item.specialtyId" :class="item.disabled?'none':''"></el-option>-->
        <!--        </el-select>-->
        <el-input style="width:200px;margin-right:10px;margin-bottom: 10px;" @clear="getPage({pageNum: 1})" v-model="queryParam.topicName" clearable placeholder="所属话题"></el-input>
        <!--        <el-date-picker v-model="queryParam.admissionOpenTime" type="datetime" format="yyyy-MM-dd HH:mm" placeholder="发布时间" style="width:200px;margin-right:10px;"></el-date-picker>-->
        <el-button @click="getPage({pageNum: 1})" type="primary">搜索</el-button>
        <el-button @click="queryParam=JSON.parse(JSON.stringify(oldQueryParam))" type="default">重置</el-button>
      </div>
    </div>
    <div ref="page" style="margin-top: 12px;">
      <el-table :data="page.list" stripe :height="tableHeight" size="medium">
        <el-table-column prop="id" label="发帖人id"></el-table-column>
        <el-table-column prop="commentCount" label="评论数"></el-table-column>
        <el-table-column prop="likeCount" label="点赞数"></el-table-column>
        <el-table-column prop="content" label="内容" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="topicList" label="所属话题">
          <template slot-scope="scope">
            <span v-for="(item) in scope.row.topicList">{{item.topicName.split(',')}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="auditStatus" label="状态">
          <template slot-scope="scope">
            {{$enums.isEnable[scope.row.isEnable]}}
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button v-if="scope.row.isEnable == 1" size="mini" type="text" style="color: #E91212;" @click="edit(scope.row.id)">屏蔽</el-button>
            <el-button v-if="scope.row.isEnable == 0" size="mini" type="text" @click="editCancel(scope.row.id)">取消屏蔽</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top: 20px;">
        <el-pagination class="text-center" background
                       :page-sizes="[20, 50, 100, 200]" layout="total, sizes, prev, pager, next, jumper"
                       :total="page.total" :page-size="page.pageSize" :current-page="page.pageNum"
                       @current-change="getPage({pageNum:$event})" @size-change="getPage({pageNum:1,pageSize:$event})"></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'community',
  components: {},
  props: [],
  data () {
    return {
      tableHeight: 200,
      queryParam: {},
      oldQueryParam: {},
      page: { pageSize: 20, pageNum: 1 }
    }
  },
  async created () {
    await this.getPage()
  },
  async mounted () {
    this.Tool.windowResizeEvent(() => {
      this.tableHeight = this.Tool.calcTableHeight(this.$refs['page'])
    })
  },
  async beforeDestroy () {
  },
  computed: {},
  watch: {},
  methods: {
    async getPage (queryParam) {
      try {
        this.queryParam = Object.assign({}, this.queryParam, queryParam)
        let page = await this.$HTTP.ApiPost.getPageInfo(this.queryParam)
        this.page = page
        this.$nextTick(() => {
          let wrapper = window.document.getElementsByClassName('el-table__body-wrapper')
          if (wrapper) {
            wrapper[0].scrollTop = 0
          }
        })
      } catch (e) {
        this.Tool.doError(e)
      }
    },
    async edit (row) {
      try {
        let confirm = await this.$confirm('确定屏蔽该用户吗？', '提示', { type: 'warning' })
        if (confirm === 'confirm') {
          await this.$HTTP.ApiPost.setForbid(row)
          this.$message({ type: 'success', message: '操作成功' })
          await this.getPage()
        }
      } catch (e) {
        this.Tool.doError(e)
      }
    },
    async editCancel (row) {
      try {
        let confirm = await this.$confirm('确定取消屏蔽该用户吗？', '提示', { type: 'warning' })
        if (confirm === 'confirm') {
          await this.$HTTP.ApiPost.cancelSetForbid(row)
          this.$message({ type: 'success', message: '操作成功' })
          await this.getPage()
        }
      } catch (e) {
        this.Tool.doError(e)
      }
    }
  }
}
</script>
